import React from "react";
import style from "css/landing.module.css";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * 파일명: CustomerArea.js
 * 작성자: 강연승
 * 작성일자: 24.02.16
 * 설명: landing page - CustomerArea
 */

function CustomerArea() {
  //반응형
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  //navigate
  const navigate = useNavigate();

  const customerList = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27,
  ];

  const itembtn = (type) => {
    return (
      <div
        className={
          type === "request" ? style.customer_card : style.customer_card2
        }
      >
        <div>{type === "request" ? "견적 문의" : "무료체험 신청"}</div>
        <div>
          <img
            alt=""
            src={
              type === "request"
                ? isMobile
                  ? process.env.REACT_APP_CLIENT_URL +
                    "img/landing/requestm.png"
                  : process.env.REACT_APP_CLIENT_URL + "img/landing/request.png"
                : isMobile
                ? process.env.REACT_APP_CLIENT_URL + "img/landing/freem.png"
                : process.env.REACT_APP_CLIENT_URL + "img/landing/free.png"
            }
          />
        </div>
        <div
          className={
            type === "request"
              ? style.estimate_active + " cursor"
              : style.estimate_none + " cursor"
          }
          onClick={() => {
            navigate(
              process.env.REACT_APP_CLIENT_URL +
                (type === "request" ? "Request" : "Free")
            );
          }}
        >
          바로가기
        </div>
      </div>
    );
  };
  return (
    <div className={style.wrapper}>
      <div className={style.customer_area}>
        <div className={style.customer_title_wrap}>
          <div className={style.customer_title}>Request for estimate</div>
          <div className={style.customer_subtitle}>
            최적의 솔루션을 제공하기 위해
            <font style={{ color: "#4787ff" }}> 간편하게 견적을 요청</font>
            하세요.
            <p style={{ height: "7px" }} />
            <font style={{ color: "#4787ff" }}> 신속하고 정확한 답변</font>을
            통해 고객님의 요구에 <font style={{ color: "#4787ff" }}>최선</font>
            을 다하겠습니다.
          </div>
        </div>
        <div>
          <div className={style.estimate}>
            {itembtn("request")}
            {itembtn("free")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerArea;
